angular.module('GatorPad.controllers.Login', [])

  .controller('LoginController', ['$rootScope', '$scope', '$location', '$http', 'ApiService', '_', '$q', function ($rootScope, $scope, $location, $http, ApiService, _, $q) {

    $scope.onLine = navigator.onLine;

    window.addEventListener("offline", function (e) {
      console.log("offline");
      $scope.onLine = false;
      $scope.$apply();
    }, false);

    window.addEventListener("online", function (e) {
      console.log("online");
      $scope.onLine = true;
      $scope.$apply();
    }, false);

    $scope.login = function () {
      ApiService.login($scope.username, $scope.password)
        .then(function (result) {

          $rootScope.sessionData = {
            username: $scope.username,
            apiSessionKey: result['session-key'],
            isAdmin: result.user.role == "admin",
            farms: _.pluck(result.user.farms, 'id')
          };

          window.localStorage.setItem("sessionData", JSON.stringify($rootScope.sessionData));
          $http.defaults.headers.common["session-key"] = $rootScope.apiSessionKey;

          ApiService.getFarmsOnline()
            .then(function (farmList) {
              var tankQs = [];
              angular.forEach(farmList, function (farm) {
                angular.forEach(farm.barns, function (barn) {
                  tankQs.push(ApiService.getTanksOnline(barn.id));
                });
              });

              $q.all(tankQs).then(function () {
                $location.path("/");
              }, function (result) {
                $scope.error = "Could not load tank data.";
              });

            }, function (result) {
              $scope.error = "Could not load farm data.";
            });
        }, function (result) {
          console.log("Failed login");
          console.log(result);
        });
    };
  }]);